import {IntegrationManager, Signals} from "@/Imports";
import Stage from "@/stage/Stage";
import Config from "@/config/Config";
import Facade from "../Facade";
import MainContainer from "@/containers/MainContainer";
import ApplicationLoader from "./ApplicationLoader";
import GameManager from "@/managers/GameManager";
import Model from "@/model/Model";
import * as PIXI from "pixi.js";
import Platform from "@/stage/Platform";
import BackendManager from "@/managers/comunication/BackendManager";
import SplashScreenContainer from "@/containers/SplashScreenContainer";
import TextFactory from "@localisation/TextFactory";

export default class Application {
  constructor () {
    this.count = 0
    Signals.loadAssets.add(this.onLoadAssets, this)

    Signals.preloaderAssetsLoadingComplete.add(this.onPreloaderAssetsLoadingComplete, this)
    Signals.mainGameAssetsLoadingComplete.add(this.onMainGameAssetsLoadingComplete, this)
    Signals.modelInitStored.add(this.onModelInitStored, this)
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)

    this.backendManager = new BackendManager()
    this.gameManager = new GameManager ()
    this.model = new Model ()

    console.log("===============", process.env.ASSETS_URL)
  }

  onLoadAssets() {
    this.appLoader = new ApplicationLoader()
    this.appLoader.loadPreloadingAssets()
  }

  onPreloaderAssetsLoadingComplete = () => {
    Config.pattern = PIXI.Loader.shared.resources['pattern'].data

    const PixiTextStyles = true ? 'PixiTextStyles' : 'PixiTextStyles2'
    const styles = PIXI.Loader.shared.resources[PixiTextStyles].data
    const strings = PIXI.Loader.shared.resources['LocalizedStrings'].data
    Facade.textFactory = new TextFactory(styles, strings, Config.locale, true)

    const locale = 'en'
    Facade.locale = Facade.urlParams.language
    Facade.textFactory.changeLocaleAndRefresh(Facade.locale)

    if (!PIXI.utils.isWebGLSupported()) {
      console.log('isWebGLSupported = FALSE')
      //setTimeout(() => this.webGlIsNotSupported(), 2000)
      Signals.errorMessage.dispatch({msg: 'Hardware Acceleration is disabled. Please enable it to continue.hardwareAccelerationButtonPage', type: 'SOMETHING WENT WRONG'})

    } else {
      Config.state = 'PRELOADER'
      this.stage = new Stage()
      this.splashScreenContainer = new SplashScreenContainer()
      this.stage.addChild(this.splashScreenContainer)

      // `if(Platform.isIOs()) {
      //   this.fullscreenController = new FullscreenIOSController()
      // }`

      if(!Platform.isMobile()) {
        document.body.style.overflow = "hidden"
      }

      this.appLoader.loadMainGameAssets()
    }
  }

  onMainGameAssetsLoadingComplete = () => {
    this.mainContainer = new MainContainer()
    this.splashScreenContainer.showContinue()

    // From the onModelInitStored
    this.stage.addChild(this.mainContainer)

    Signals.initUI.dispatch()
    document.dispatchEvent(new CustomEvent("show", {}))
  }

  onModelInitStored() {
  }

  onContinueBtnClick() {
    if(this.splashScreenContainer) {
      this.splashScreenContainer.destroy()
      this.stage.removeChild(this.splashScreenContainer)
      this.splashScreenContainer = null
    }
  }

  onURLParametersParsed(data) {

  }

  webGlIsNotSupported() {
    const title = new Facade.textFactory.getTextWithStyle('hardwareAccelerationSupportTitle')
    const message = new Facade.textFactory.getTextWithStyle('hardwareAccelerationSupport')

    const event = new CustomEvent('showPopup', {
      detail: {
        visible: true,
        innerhtml: `
             <div style="background-color: rgba(100, 100, 100, 1);
         
         padding: 20px;
         width: 500px;
         margin: auto;
         margin-left: -250px;
         margin-top: -125px;
         text-align: center;
         height: 250px;
         color: white;
         border-radius: 10px;
         font-size: 12px">
     <h1 style="text-align: center; color: #FFFFFF">${title.text}</h1>
     <span style="font-size: 20px; text-align: center; color: #FFFFFF">${message.text}</span>
     <br>
     <br>
     <br>
        <button class="previous" style="border-radius: 8px; height: 50px; width: 100px; text-align: center">PREVIOUS PAGE</button>\`
     </div>
             `
      }
    })

    document.dispatchEvent(event)
  }
}
